import axios from 'axios'
import { interceptor } from '@/application/utils/interceptor.js'

const domain = process.env.VUE_APP_API_PATH
const sendHttpLinkApi = (id) => `${domain}api/v1/dashboard/request/sender-name/${id}/`

export const sendHttpLinkRequest = (id, data) => interceptor(axios).post(sendHttpLinkApi(id), data)
